import { useCallback, useEffect, useState } from 'react';
import { creationRequestsAPI } from '../services/api';
import { getApiErrorMessage } from '../utils/apiErrorMessage';

export default function useCreationRequestNotifiers() {
  const [staff, setStaff] = useState([]);
  const [notifyUserIds, setNotifyUserIds] = useState([]);
  const [busyId, setBusyId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await creationRequestsAPI.getSettings();
      const data = res.data?.data || {};
      setStaff(data.staff || []);
      setNotifyUserIds(data.notifyUserIds || []);
    } catch (err) {
      setError(getApiErrorMessage(err, 'Could not load who is notified'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const setNotified = useCallback(
    async (userId, enabled) => {
      setBusyId(userId);
      setError('');
      const next = enabled
        ? [...new Set([...notifyUserIds, userId])]
        : notifyUserIds.filter((id) => id !== userId);
      try {
        await creationRequestsAPI.updateSettings({ notifyUserIds: next });
        setNotifyUserIds(next);
        setStaff((rows) =>
          rows.map((u) => (u.id === userId ? { ...u, notified: enabled } : u))
        );
      } catch (err) {
        setError(getApiErrorMessage(err, 'Could not update notification list'));
      } finally {
        setBusyId(null);
      }
    },
    [notifyUserIds]
  );

  return {
    staff,
    selectedCount: notifyUserIds.length,
    busyId,
    loading,
    error,
    setNotified,
  };
}
